"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _Animation = _interopRequireDefault(require("./Animation"));

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _designLanguage = require("@doordash/design-language");

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var animationForState = function animationForState(state) {
  switch (state) {
    case _constants.States.FoodLoop:
      return _constants.FOOD_LOOP_ANIMATION_OPTIONS;

    case _constants.States.Error:
      return _constants.ERROR_ANIMATION_OPTIONS;

    case _constants.States.Success:
      return _constants.SUCCESS_ANIMATION_OPTIONS;

    case _constants.States.Loading:
    default:
      return _constants.LOADING_ANIMATION_OPTIONS;
  }
};

var keyForState = function keyForState(state) {
  switch (state) {
    case _constants.States.FoodLoop:
      return 'FOOD_LOOP';

    case _constants.States.Error:
      return 'ERROR';

    case _constants.States.Success:
      return 'SUCCESS';

    case _constants.States.Loading:
    default:
      return 'LOADING';
  }
};

var Loading = function Loading(_ref) {
  var state = _ref.state,
      color = _ref.color,
      size = _ref.size,
      _onAnimationEnd = _ref.onAnimationEnd,
      _onAnimationLoopEnd = _ref.onAnimationLoopEnd;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  return /*#__PURE__*/_react["default"].createElement(_styles.LoadingRoot, {
    color: color || theme.Colors.LoadingDefault,
    state: state
  }, /*#__PURE__*/_react["default"].createElement(_Animation["default"], {
    key: keyForState(state),
    options: animationForState(state),
    width: size,
    height: size,
    onAnimationEnd: function onAnimationEnd() {
      return _onAnimationEnd(keyForState(state));
    },
    onAnimationLoopEnd: function onAnimationLoopEnd() {
      return _onAnimationLoopEnd(keyForState(state));
    }
  }));
};

Loading.Sizes = _constants.Sizes;
Loading.States = _constants.States;
Loading.Colors = _constants.Colors;
Loading.propTypes = {
  size: _propTypes["default"].oneOf(Object.values(Loading.Sizes)),
  state: _propTypes["default"].oneOf(Object.values(Loading.States)),
  color: _propTypes["default"].oneOf(Object.values(Loading.Colors), (0, _utilities.getAllPropCasesForColors)(Object.values(Loading.Colors))),
  onAnimationEnd: _propTypes["default"].func,
  onAnimationLoopEnd: _propTypes["default"].func
};
Loading.defaultProps = {
  size: Loading.Sizes.Medium,
  state: Loading.States.Loading,
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationLoopEnd: function onAnimationLoopEnd() {}
};
var _default = Loading;
exports["default"] = _default;